export default "__VITE_ASSET__DEGEeErc__"